module.exports = __webpack_public_path__ + "87a87a42e95b2a464d920dc904f22852.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-28.png
// module id = 2139
// module chunks = 0